// extracted by mini-css-extract-plugin
export default {"container":"slideshow_container__ir29z","image":"slideshow_image__KPsgX","active":"slideshow_active__2vVyD","photoCredits":"slideshow_photoCredits__7JNad"};